const SLOT_TIERS = [
  { range: "1–10", price: 3, slots: 10 },
  { range: "11–30", price: 2, slots: 20 },
  { range: "31–60", price: 1.5, slots: 30 },
  { range: "61+", price: 1, slots: Infinity },
];

const PAYMENTS_PRO_MONTHLY = 10;

export function calculateSlotCost(slots) {
  const breakdown = [];
  let remaining = slots;
  let total = 0;
  let slotStart = 1;

  for (const tier of SLOT_TIERS) {
    if (remaining <= 0) break;
    const slotsInTier = Math.min(
      remaining,
      tier.slots === Infinity ? remaining : tier.slots
    );
    const tierCost = slotsInTier * tier.price;
    const slotEnd = slotStart + slotsInTier - 1;
    const rangeLabel =
      tier.slots === Infinity && slotEnd === slotStart
        ? `${slotStart}+`
        : `${slotStart}–${slotEnd}`;
    breakdown.push({
      range: rangeLabel,
      slots: slotsInTier,
      pricePerSlot: tier.price,
      cost: tierCost,
    });
    total += tierCost;
    remaining -= slotsInTier;
    slotStart += slotsInTier;
  }

  return { breakdown, total };
}

export function calculateTotalWithPaymentsPro(slots, paymentsPro) {
  const { breakdown, total } = calculateSlotCost(slots);
  const paymentsProCost = paymentsPro ? PAYMENTS_PRO_MONTHLY : 0;
  return { breakdown, total: total + paymentsProCost, paymentsProCost };
}
